import { TokenResponse } from "@/api/types";
import axios from "axios";

export const login = (usernameOrEmail: string, password: string, captcha: string, two_factor_code?: string, recovery_code?: string) =>
    axios.post<TokenResponse>('auth/login', { username: usernameOrEmail, password, captcha, two_factor_code, recovery_code });
export const register = (username: string, email: string, password: string, captcha: string) =>
    axios.post<TokenResponse>('auth/register', { username, email, password, captcha });
export const forgotPassword = (email: string, captcha: string) =>
    axios.post('auth/forgot-password', { email, captcha });
export const resetPassword = (email: string, token: string, password: string) =>
    axios.post('auth/reset-password', { email, token, password });
export const logout = () => axios.post('auth/logout');
